import i18n from "i18next";

export function BasicText(base) {
  return {
    getConfig: function () {
      return {
        name: "BasicText",
        displayName: IdealStudio.i18n.t("BasicText.PluginName"),
        category: "text",
        needsConfigModal: false,
        needsTextEdition: true,
        initialWidth: "auto",
        initialWidthSlide: "30%",
        /* initialHeight: '100px',*/
        icon: "subject",
        flavor: "plain",
      };
    },
    getToolbar: function (state) {
      return {
        main: {
          __name: "Main",
          accordions: {
            style: {
              __name: IdealStudio.i18n.t("BasicText.box_style"),
              icon: "palette",
              buttons: {
                padding: {
                  __name: IdealStudio.i18n.t("BasicText.padding"),
                  type: "number",
                  value: 7,
                  min: 0,
                  max: 100,
                },
                backgroundColor: {
                  __name: IdealStudio.i18n.t("BasicText.background_color"),
                  type: "color",
                  value: "rgba(255,255,255,0)",
                },
                borderWidth: {
                  __name: IdealStudio.i18n.t("BasicText.border_size"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 10,
                },
                borderStyle: {
                  __name: IdealStudio.i18n.t("BasicText.border_style"),
                  type: "select",
                  value: "solid",
                  options: [
                    "none",
                    "hidden",
                    "dotted",
                    "dashed",
                    "solid",
                    "double",
                    "groove",
                    "ridge",
                    "inset",
                    "outset",
                    "initial",
                    "inherit",
                  ],
                  labels: [
                    i18n.t("styles.border_style_options.none") || "none",
                    i18n.t("styles.border_style_options.hidden") || "hidden",
                    i18n.t("styles.border_style_options.dotted") || "dotted",
                    i18n.t("styles.border_style_options.dashed") || "dashed",
                    i18n.t("styles.border_style_options.solid") || "solid",
                    i18n.t("styles.border_style_options.double") || "double",
                    i18n.t("styles.border_style_options.groove") || "groove",
                    i18n.t("styles.border_style_options.ridge") || "ridge",
                    i18n.t("styles.border_style_options.inset") || "inset",
                    i18n.t("styles.border_style_options.outset") || "outset",
                    i18n.t("styles.border_style_options.initial") || "initial",
                    i18n.t("styles.border_style_options.inherit") || "inherit",
                  ],
                },
                borderColor: {
                  __name: IdealStudio.i18n.t("BasicText.border_color"),
                  type: "color",
                  value: "#000000",
                },
                borderRadius: {
                  __name: IdealStudio.i18n.t("BasicText.radius"),
                  type: "number",
                  value: 0,
                  min: 0,
                  max: 50,
                },
                opacity: {
                  __name: IdealStudio.i18n.t("BasicText.opacity"),
                  type: "range",
                  value: 1,
                  min: 0,
                  max: 1,
                  step: 0.01,
                },
                /* ,
                                className: {
                                    __name: IdealStudio.i18n.t('BasicText.classname'),
                                    type: 'text',
                                },*/
              },
            },
          },
        },
      };
    },
  };
}
/* eslint-enable react/prop-types */
